import { render } from "./getInnerStudy.vue?vue&type=template&id=1cba1f64&scoped=true"
import script from "./getInnerStudy.vue?vue&type=script&lang=js"
export * from "./getInnerStudy.vue?vue&type=script&lang=js"

import "./getInnerStudy.vue?vue&type=style&index=0&id=1cba1f64&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cba1f64"]])

export default __exports__